module.exports = __webpack_public_path__ + "static/media/NextMonthIcon.53757bbb.svg";